import {
  Component, OnInit, Input, Output, EventEmitter, Renderer2, ElementRef, ViewChild, OnDestroy
} from '@angular/core';
import { MessageQuoteQuery } from '@model/webFeeder/message-quote-query.model';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { CustomWorkspaceItemDto } from '@dto/custom-workspace-item.dto';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { Subscription , of } from 'rxjs';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { AuthServer } from '@services/auth-server.service';

@Component({
  selector: 'app-component-selector-input',
  templateUrl: './component-selector-input.component.html',
})
export class ComponentSelectorInputComponent implements OnInit, OnDestroy {

  @ViewChild('csi') currentComponent: ElementRef;
  @Input() cardTitle: any;
  @Output() addSelectInput = new EventEmitter();
  private successAdded: Subscription;
  public button_selected = false;
  public loading = false;
  public company: string;
  private subscriptionQuote: Subscription;
  public model: CustomWorkspaceItemDto;
  @Input() symbolAutoComplete: string;
  @Input() hiddenError: boolean;
  @Output() onsymbolChanged = new EventEmitter<MessageQuoteQuery>();
  public filteredAssets: any;
  public hiddenInvalidActive = false;

  constructor(
    private renderer: Renderer2,
    private _authServer: AuthServer,
    private _notificationService?: NotificationsService,
    private quoteService?: QuoteService,
    private workspaceService?: WorkspaceNewService
  ) {
  }

  ngOnInit() {
    this.model = new CustomWorkspaceItemDto(null, this.cardTitle.id, '', '', this.cardTitle.title, false);
    this.successAdded = this.workspaceService._successAddComponent$.subscribe(response => {
      if (response && response.type == this.cardTitle.id && response.sucess) {
        this.model = new CustomWorkspaceItemDto(null, this.cardTitle.id, '', '', this.cardTitle.title, false);
      }
    });
  }

  ngOnDestroy() {
    if (this.subscriptionQuote) {
      this.subscriptionQuote.unsubscribe();
    }
    if (this.successAdded) {
      this.successAdded.unsubscribe();
    }
  }

  changeClass() {
    this.button_selected = !this.button_selected;
  }

  addComponent() {
    this.loading = true;
    this.changeClass();
    this.cardEffect(this.currentComponent);
    this.model.company = '';
    this.company = '';
    this.addSelectInput.emit(this.model);
    setTimeout(() => {
      this.changeClass();
      this.loading = false;
    }, 500);
  }

  public onAutoCompletAsset(textInput: any, source?: string) {
    if (textInput.key.includes('Enter')) {
      this.onInputEnter(textInput, source);
    } else {
      if (textInput.key !== 'ArrowDown' && textInput.key !== 'ArrowUp') {
        let symbolAutoComplete = '';
        if (textInput.target === undefined) {
          symbolAutoComplete = textInput.toLowerCase();
        } else {
          symbolAutoComplete = textInput.target.value.toLowerCase();
        }
        if (symbolAutoComplete.length >= 1) {
          this._authServer.iQuote.quotesQuery(symbolAutoComplete)
            .subscribe(datas => {
              if (datas && datas.length > 0) {
                this.filteredAssets = datas;
              } else {
                this.filteredAssets = [];
              }
            });
        }
      }
    }
  }

  onInputEnter(event, source?: string) {
    if (event.target.value === '' && event.key.includes('Enter')) {
      this._notificationService.warn('Ops,', Constants.WORKSPACE_MSG005);
    } else if (event.key.includes('Enter')) {
      this.setQuote(event.target.value, source);
    } else {
      return false;
    }
  }

  cardEffect(cardRef: ElementRef): void {
    const elementLeft = cardRef.nativeElement.offsetLeft;
    const windowWidth = window.innerWidth;
    const elementTop = cardRef.nativeElement.offsetTop;
    const verticalFinalPosition = windowWidth - elementLeft - 315;
    const horizontalFinalPosition = window.innerHeight / 2 - 300;

    this.renderer.setStyle(cardRef.nativeElement, 'right', '-' + verticalFinalPosition + 'px');

    if (elementTop > window.innerHeight / 2) {
      this.renderer.setStyle(cardRef.nativeElement, 'top', '-' + horizontalFinalPosition + 'px');
    } else {
      this.renderer.setStyle(cardRef.nativeElement, 'top', horizontalFinalPosition + 'px');
    }

    setTimeout(() => {
      this.renderer.setStyle(cardRef.nativeElement, 'top', '0px');
      this.renderer.setStyle(cardRef.nativeElement, 'right', '0px');
    }, 500);
  }


  public onBlur(quoteSymbol?: string, source?, symbolAutoComplete?: string, itemSelected?: string) {
    this.setQuote(quoteSymbol, source);
  }

  onchangeSymbol(evento, source?, symbolAutoComplete?: string, itemSelected?: string) {
    this.setQuote(itemSelected, source);

  }

  public onQuoteChange(quoteSymbol?: string, source?, symbolAutoComplete?: string, itemSelected?: string) {
    let searchSymbol;
    if (quoteSymbol) {
      if (quoteSymbol.length >= 2) {
        if (this.filteredAssets && this.filteredAssets.length > 0) {
          const symbolTemp = this.filteredAssets.filter(asset => asset.symbol.toUpperCase() === quoteSymbol.toUpperCase());
          if (symbolTemp.length === 0) {
            searchSymbol = quoteSymbol;
          } else {
            searchSymbol = symbolTemp[0].symbol;
            this.filteredAssets = [];
            this.hiddenInvalidActive = false;
            this.model.assetSymbol = symbolTemp[0].symbol;
            this.filteredAssets = [];
          }
        } else {
          searchSymbol = quoteSymbol;
        }
        this.setQuote(searchSymbol, source);
      } else {
        return false;
      }
    }
  }

  setQuote(value: any, source: any) {
    if (value) {
      if (this.subscriptionQuote) {
        this.subscriptionQuote.unsubscribe();
      }
      this.quoteService.subscribeQuote(value.toLowerCase(), Constants.WINDOW_NAME_SELECTOR_INPUT);
      let countValid = 0;
      this.subscriptionQuote = this.quoteService.messagesQuote
        .subscribe((data: MessageQuote) => {
          if (data && data.errorMessage && data.symbol.toLowerCase() === value.toLowerCase()
            && this.cardTitle.id.toLowerCase() === source) {
            if (countValid === 0) {
              this.hiddenInvalidActive = true;
              this.model.company = this.company = '';
              this.quoteService.unsubscribeQuote(value.toLowerCase(), Constants.WINDOW_NAME_SELECTOR_INPUT);
              this.filteredAssets = [];
              countValid++;
              return false;
            }
          } else if (data !== undefined && data.symbol != null && data.symbol.toLowerCase() === value.toLowerCase()
            && this.cardTitle.id.toLowerCase() === source) {
            if (countValid === 0) {
              this.hiddenInvalidActive = false;
              this.model.company = this.company = data.description.toLocaleUpperCase();
              this.model.assetSymbol = data.symbol.toLocaleUpperCase();
              this.filteredAssets = [];
              this.quoteService.unsubscribeQuote(value.toLowerCase(), Constants.WINDOW_NAME_SELECTOR_INPUT);
              countValid++;
              return true;
            }
          }
        });
    } else {
      this.hiddenInvalidActive = true;
      this.model.company = this.company = '';
      this.quoteService.unsubscribeQuote(value.toLowerCase(), Constants.WINDOW_NAME_SELECTOR_INPUT);
      this.filteredAssets = [];
    }
  }

  optionSelected(event) {
    const symbol = event.option.value.toLowerCase();
    const messageQuoteQuery = new MessageQuoteQuery();
    this.symbolAutoComplete = symbol;
    this.filteredAssets = [];
    messageQuoteQuery.symbol = this.symbolAutoComplete.toUpperCase();
    messageQuoteQuery.company = this.company;
    this.onsymbolChanged.emit(messageQuoteQuery);
  }


}
